import React from 'react';
import { Search } from 'lucide-react';

export function SearchInput({ value, onChange, placeholder = "Buscar..." }) {
  return (
    <div className="searchBar">
      <Search size={18}/>
      <input 
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder} 
      />
    </div>
  );
}
